// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ajax-file-upload-statusbar {
border: 1px solid #0ba1b5;
margin-top: 10px;
width: 420px;
margin-right: 10px;
margin: 5px;
-moz-border-radius: 4px;
-webkit-border-radius: 4px;
border-radius: 4px;
padding: 5px 5px 5px 15px
}

.ajax-file-upload-filename {
width: 300px;
height: auto;
margin: 0 5px 5px 0px;

}

.ajax-file-upload-filesize {
width: 50px;
height: auto;
margin: 0 5px 5px 0px;
display: inline-block;
vertical-align:middle;
}
.ajax-file-upload-progress {
margin: 5px 10px 5px 0px;
position: relative;
width: 250px;
border: 1px solid #ddd;
padding: 1px;
border-radius: 3px;
display: inline-block;
color:#FFFFFF;

}
.ajax-file-upload-bar {
background-color: #15719f;
width: 0;
height: 20px;
border-radius: 3px;
color:#FFFFFF;

}
.ajax-file-upload-percent {
position: absolute;
display: inline-block;
top: 3px;
left: 48%
}
.ajax-file-upload-red {
-moz-box-shadow: inset 0 39px 0 -24px #e67a73;
-webkit-box-shadow: inset 0 39px 0 -24px #e67a73;
box-shadow: inset 0 39px 0 -24px #e67a73;
background-color: #e4685d;
-moz-border-radius: 4px;
-webkit-border-radius: 4px;
border-radius: 4px;
display: inline-block;
color: #fff;
font-family: arial;
font-size: 13px;
font-weight: normal;
padding: 4px 15px;
text-decoration: none;
text-shadow: 0 1px 0 #b23e35;
cursor: pointer;
vertical-align: top;
margin: 5px 10px 5px 0px;
}
.ajax-file-upload-green {
background-color: #77b55a;
-moz-border-radius: 4px;
-webkit-border-radius: 4px;
border-radius: 4px;
margin: 0;
padding: 0;
display: inline-block;
color: #fff;
font-family: arial;
font-size: 13px;
font-weight: normal;
padding: 4px 15px;
text-decoration: none;
cursor: pointer;
text-shadow: 0 1px 0 #5b8a3c;
vertical-align: top;
margin: 5px 10px 5px 0px;
}
.ajax-file-upload {
	font-family: Arial, Helvetica, sans-serif;
	font-size: 16px;
   font-weight: bold;
	padding: 15px 20px;
	cursor:pointer;
	line-height:20px;
	height:25px;
	margin:0 10px 10px 0;
  display: inline-block;
  background: #fff;
  border: 1px solid #e8e8e8;
  color: #888;
  text-decoration: none;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -moz-box-shadow: 0 2px 0 0 #e8e8e8;
  -webkit-box-shadow: 0 2px 0 0 #e8e8e8;
  box-shadow: 0 2px 0 0 #e8e8e8;
  padding: 6px 10px 4px 10px;
  color: #fff;
  background: #15719f;
  border: none;
  -moz-box-shadow: 0 2px 0 0 #13648d;
  -webkit-box-shadow: 0 2px 0 0 #13648d;
  box-shadow: 0 2px 0 0 #13648d;
  vertical-align: middle;
  }

.ajax-file-upload:hover {
      background: #15719f;
      -moz-box-shadow: 0 2px 0 0 #15719f;
      -webkit-box-shadow: 0 2px 0 0 #15719f;
      box-shadow: 0 2px 0 0 #15719f;
}

.ajax-upload-dragdrop
{
	border:2px dotted #A5A5C7;
	width:420px;
	color: #000;
	text-align:left;
	vertical-align:middle;
	padding:10px 10px 0px 10px;
}

.state-hover
{
		border:2px solid #A5A5C7;
}
.ajax-file-upload-container
{
	margin:20px 0px 20px 0px;
}`, "",{"version":3,"sources":["webpack://./src/scss/uploadfile.css"],"names":[],"mappings":"AAAA;AACA,yBAAyB;AACzB,gBAAgB;AAChB,YAAY;AACZ,kBAAkB;AAClB,WAAW;AACX,uBAAuB;AACvB,0BAA0B;AAC1B,kBAAkB;AAClB;AACA;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ,qBAAqB;;AAErB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,qBAAqB;AACrB,qBAAqB;AACrB,qBAAqB;AACrB;AACA;AACA,wBAAwB;AACxB,kBAAkB;AAClB,YAAY;AACZ,sBAAsB;AACtB,YAAY;AACZ,kBAAkB;AAClB,qBAAqB;AACrB,aAAa;;AAEb;AACA;AACA,yBAAyB;AACzB,QAAQ;AACR,YAAY;AACZ,kBAAkB;AAClB,aAAa;;AAEb;AACA;AACA,kBAAkB;AAClB,qBAAqB;AACrB,QAAQ;AACR;AACA;AACA;AACA,6CAA6C;AAC7C,gDAAgD;AAChD,wCAAwC;AACxC,yBAAyB;AACzB,uBAAuB;AACvB,0BAA0B;AAC1B,kBAAkB;AAClB,qBAAqB;AACrB,WAAW;AACX,kBAAkB;AAClB,eAAe;AACf,mBAAmB;AACnB,iBAAiB;AACjB,qBAAqB;AACrB,4BAA4B;AAC5B,eAAe;AACf,mBAAmB;AACnB,wBAAwB;AACxB;AACA;AACA,yBAAyB;AACzB,uBAAuB;AACvB,0BAA0B;AAC1B,kBAAkB;AAClB,SAAS;AACT,UAAU;AACV,qBAAqB;AACrB,WAAW;AACX,kBAAkB;AAClB,eAAe;AACf,mBAAmB;AACnB,iBAAiB;AACjB,qBAAqB;AACrB,eAAe;AACf,4BAA4B;AAC5B,mBAAmB;AACnB,wBAAwB;AACxB;AACA;CACC,yCAAyC;CACzC,eAAe;GACb,iBAAiB;CACnB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,oBAAoB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;EAC7B,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;EAC7B,sBAAsB;EACtB;;AAEF;MACM,mBAAmB;MACnB,kCAAkC;MAClC,qCAAqC;MACrC,6BAA6B;AACnC;;AAEA;;CAEC,yBAAyB;CACzB,WAAW;CACX,WAAW;CACX,eAAe;CACf,qBAAqB;CACrB,0BAA0B;AAC3B;;AAEA;;EAEE,wBAAwB;AAC1B;AACA;;CAEC,wBAAwB;AACzB","sourcesContent":[".ajax-file-upload-statusbar {\r\nborder: 1px solid #0ba1b5;\r\nmargin-top: 10px;\r\nwidth: 420px;\r\nmargin-right: 10px;\r\nmargin: 5px;\r\n-moz-border-radius: 4px;\r\n-webkit-border-radius: 4px;\r\nborder-radius: 4px;\r\npadding: 5px 5px 5px 15px\r\n}\r\n\r\n.ajax-file-upload-filename {\r\nwidth: 300px;\r\nheight: auto;\r\nmargin: 0 5px 5px 0px;\r\n\r\n}\r\n\r\n.ajax-file-upload-filesize {\r\nwidth: 50px;\r\nheight: auto;\r\nmargin: 0 5px 5px 0px;\r\ndisplay: inline-block;\r\nvertical-align:middle;\r\n}\r\n.ajax-file-upload-progress {\r\nmargin: 5px 10px 5px 0px;\r\nposition: relative;\r\nwidth: 250px;\r\nborder: 1px solid #ddd;\r\npadding: 1px;\r\nborder-radius: 3px;\r\ndisplay: inline-block;\r\ncolor:#FFFFFF;\r\n\r\n}\r\n.ajax-file-upload-bar {\r\nbackground-color: #15719f;\r\nwidth: 0;\r\nheight: 20px;\r\nborder-radius: 3px;\r\ncolor:#FFFFFF;\r\n\r\n}\r\n.ajax-file-upload-percent {\r\nposition: absolute;\r\ndisplay: inline-block;\r\ntop: 3px;\r\nleft: 48%\r\n}\r\n.ajax-file-upload-red {\r\n-moz-box-shadow: inset 0 39px 0 -24px #e67a73;\r\n-webkit-box-shadow: inset 0 39px 0 -24px #e67a73;\r\nbox-shadow: inset 0 39px 0 -24px #e67a73;\r\nbackground-color: #e4685d;\r\n-moz-border-radius: 4px;\r\n-webkit-border-radius: 4px;\r\nborder-radius: 4px;\r\ndisplay: inline-block;\r\ncolor: #fff;\r\nfont-family: arial;\r\nfont-size: 13px;\r\nfont-weight: normal;\r\npadding: 4px 15px;\r\ntext-decoration: none;\r\ntext-shadow: 0 1px 0 #b23e35;\r\ncursor: pointer;\r\nvertical-align: top;\r\nmargin: 5px 10px 5px 0px;\r\n}\r\n.ajax-file-upload-green {\r\nbackground-color: #77b55a;\r\n-moz-border-radius: 4px;\r\n-webkit-border-radius: 4px;\r\nborder-radius: 4px;\r\nmargin: 0;\r\npadding: 0;\r\ndisplay: inline-block;\r\ncolor: #fff;\r\nfont-family: arial;\r\nfont-size: 13px;\r\nfont-weight: normal;\r\npadding: 4px 15px;\r\ntext-decoration: none;\r\ncursor: pointer;\r\ntext-shadow: 0 1px 0 #5b8a3c;\r\nvertical-align: top;\r\nmargin: 5px 10px 5px 0px;\r\n}\r\n.ajax-file-upload {\r\n\tfont-family: Arial, Helvetica, sans-serif;\r\n\tfont-size: 16px;\r\n   font-weight: bold;\r\n\tpadding: 15px 20px;\r\n\tcursor:pointer;\r\n\tline-height:20px;\r\n\theight:25px;\r\n\tmargin:0 10px 10px 0;\r\n  display: inline-block;\r\n  background: #fff;\r\n  border: 1px solid #e8e8e8;\r\n  color: #888;\r\n  text-decoration: none;\r\n  border-radius: 3px;\r\n  -webkit-border-radius: 3px;\r\n  -moz-border-radius: 3px;\r\n  -moz-box-shadow: 0 2px 0 0 #e8e8e8;\r\n  -webkit-box-shadow: 0 2px 0 0 #e8e8e8;\r\n  box-shadow: 0 2px 0 0 #e8e8e8;\r\n  padding: 6px 10px 4px 10px;\r\n  color: #fff;\r\n  background: #15719f;\r\n  border: none;\r\n  -moz-box-shadow: 0 2px 0 0 #13648d;\r\n  -webkit-box-shadow: 0 2px 0 0 #13648d;\r\n  box-shadow: 0 2px 0 0 #13648d;\r\n  vertical-align: middle;\r\n  }\r\n\r\n.ajax-file-upload:hover {\r\n      background: #15719f;\r\n      -moz-box-shadow: 0 2px 0 0 #15719f;\r\n      -webkit-box-shadow: 0 2px 0 0 #15719f;\r\n      box-shadow: 0 2px 0 0 #15719f;\r\n}\r\n\r\n.ajax-upload-dragdrop\r\n{\r\n\tborder:2px dotted #A5A5C7;\r\n\twidth:420px;\r\n\tcolor: #000;\r\n\ttext-align:left;\r\n\tvertical-align:middle;\r\n\tpadding:10px 10px 0px 10px;\r\n}\r\n\r\n.state-hover\r\n{\r\n\t\tborder:2px solid #A5A5C7;\r\n}\r\n.ajax-file-upload-container\r\n{\r\n\tmargin:20px 0px 20px 0px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
